<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="xrx-checkbox" (click)="onToggle()">
  <label
    [for]="name"
    [xdaTranslate]="label"
    [ngClass]="{ 'disabled-checkbox-label': isDisabled }"></label>
  <div
    class="checkbox"
    [ngClass]="{
      checked: checkBoxValue,
      partial: isPartial,
      disabled: isDisabled,
    }">
    <span class="icons">
      <span
        class="first-icon xgl-check_off glyph-chbx-radio-theme-uchkd"></span>
      <span class="second-icon xgl-check_on glyph-chbx-radio-theme-chkd"></span>
      <span
        class="third-icon xgl-subtract_square_alt glyph-chbx-radio-theme-partial"></span>
    </span>
    <input type="checkbox" value="" [name]="name" />
  </div>
</div>
